<template>
  <div>
    <page-main
      ref="tableMain"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      :shipmentCode="shipmentCode"
      :custCode="custCode"
      :disabled="disabled"
      :height="height"
      @reload="reload"
      @confirm="chooseContainerBoxConfirm"
    >
      <page-header
        ref="header"
        slot="header"
        :disabled="disabled"
        :shipmentCode="shipmentCode"
        @query="getData"
        @reset="resetPage"
        @confirm="$refs.tableMain.getCheckboxRecords()"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'

export default {
  components: {
    PageHeader,
    PageMain,
  },
  mixins: [BaseTable],
  props: {
    shipmentCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    height: { type: Number, default: 600 },
  },
  data() {
    return {
      usePage: true,
      custCode: '',
      containerBoxParams: {
        visible: false,
        title: '',
        disabled: false,
        code: '',
      },
    }
  },
  methods: {
    getData(form) {
      if (!this.shipmentCode) return
      this.loading = true
          const param = {
            shipmentCode: this.shipmentCode,
            ...form,
            ...this.page
          }
          this.$api
            .orderBatchPendingListApi(param)
            .then((res) => {
              this.loading = false
              this.setData(res)
            })
            .catch(() => {
              this.loading = false
            })
    },
    chooseContainerBoxConfirm() {
      this.$emit('confirm')
    },
  },
}
</script>
